import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import cn from '../../utils/cn';

export enum SeparatorOrientation {
  HORIZONTAL,
  VERTICAL,
}

export type SeparatorProps = Omit<
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>,
  'orientation'
> & {
  orientation?: SeparatorOrientation;
};

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  SeparatorProps
>(
  (
    {
      className,
      orientation = SeparatorOrientation.HORIZONTAL,
      decorative = true,
      ...props
    },
    ref,
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={
        orientation === SeparatorOrientation.HORIZONTAL ? 'horizontal' : 'vertical'
      }
      className={cn(
        'shrink-0 self-stretch rounded-full bg-neutral-300',
        orientation === SeparatorOrientation.HORIZONTAL ? 'h-px' : 'w-px',
        className,
      )}
      {...props}
    />
  ),
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export default Separator;
